interface ProductDescription {
  id: number;
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

interface ProductSpecsTableProps {
  descriptions: ProductDescription[];
}

const COLUMNS: { key: keyof ProductDescription; label: string }[] = [
  { key: "type", label: "Type" },
  { key: "standardMaterial", label: "Standard Material" },
  { key: "pressure", label: "Pressure" },
  { key: "temperature", label: "Temperature" },
  { key: "surfaceSpeed", label: "Surface Speed" },
];

export default function ProductSpecsTable({ descriptions }: ProductSpecsTableProps) {
  if (!descriptions || descriptions.length === 0) return null;

  return (
    <div className="overflow-x-auto rounded-2xl border border-slate-100">
      <table className="w-full min-w-[640px] text-left text-sm">
        <thead>
          <tr className="bg-slate-50 text-slate-500">
            <th className="px-5 py-3 font-medium">Varian</th>
            {COLUMNS.map((col) => (
              <th key={col.key} className="px-5 py-3 font-medium">
                {col.label}
              </th>
            ))}
            <th className="px-5 py-3 font-medium">Stock</th>
          </tr>
        </thead>
        <tbody>
          {descriptions.map((desc, index) => (
            <tr
              key={desc.id}
              className={`border-t border-slate-100 ${
                index % 2 === 1 ? "bg-slate-50/50" : ""
              }`}>
              <td className="px-5 py-3.5 font-semibold text-[#324A5A]">
                Varian {index + 1}
              </td>
              {COLUMNS.map((col) => (
                <td key={col.key} className="px-5 py-3.5 text-slate-600">
                  {String(desc[col.key] ?? "-")}
                </td>
              ))}
              <td className="px-5 py-3.5">
                {desc.unlimited ? (
                  <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-600">
                    Unlimited
                  </span>
                ) : (
                  <span
                    className={`rounded-full px-3 py-1 text-xs font-medium ${
                      desc.stock > 0
                        ? "bg-emerald-50 text-emerald-600"
                        : "bg-red-50 text-red-500"
                    }`}>
                    {desc.stock} pcs
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
